"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var data_catalog_shared_1 = require("@tableau/data-catalog-shared");
var widgets_1 = require("@tableau/widgets");
var ButtonWidget_1 = require("@tableau/widgets/lib/src/widgets/Button/ButtonWidget");
var React = require("react");
var Expand_1 = require("../../../gen-src/icons/Expand");
var Localize_1 = require("../../../gen-src/Localize");
var TableauExpressionFormatter_1 = require("../tableauExpression/components/TableauExpressionFormatter");
var CalculationDialog_1 = require("./CalculationDialog");
var VizClientFieldCardStyles_1 = require("./VizClientFieldCardStyles");
function CalculationDetails(props) {
    var _a = React.useState(false), isOpen = _a[0], toggleDialog = _a[1];
    var openDialog = function () { return toggleDialog(true); };
    var onClose = function () { return toggleDialog(false); };
    var formula = props.field.formula;
    return (React.createElement(React.Fragment, null,
        React.createElement(VizClientFieldCardStyles_1.FieldCardDetailTitleWrapper, null,
            React.createElement(VizClientFieldCardStyles_1.FieldCardDetailTitle, null, Localize_1.Messages.DataDetailsCalculation()),
            React.createElement(VizClientFieldCardStyles_1.ExpandIconWrapper, null,
                React.createElement(widgets_1.ButtonWidget, { buttonType: ButtonWidget_1.ButtonType.Icon, handleClick: openDialog, title: Localize_1.Messages.DataDetailsCalculationDialogExpandAltText(), testId: 'data-details-calculation-expand', getContent: function () { return React.createElement(Expand_1.SvgExpand, null); } }))),
        React.createElement(VizClientFieldCardStyles_1.FieldCardDetailText, null,
            React.createElement(data_catalog_shared_1.SiteUrlsContext.Consumer, null, function (urls) {
                return React.createElement(React.Fragment, null,
                    React.createElement(TableauExpressionFormatter_1.TableauExpressionFormatter, { expression: formula, fields: props.field.fields, parameters: props.field.parameters, makeFieldUrl: function (fieldId) {
                            return props.workbookVizportalUrlId
                                ? urls.workbookLineageFieldUrl(props.workbookVizportalUrlId, fieldId)
                                : '';
                        }, openLinksInNewTab: true }),
                    React.createElement(CalculationDialog_1.CalculationDialog, { isOpen: isOpen, onClose: onClose, field: props.field, workbookVizportalUrlId: props.workbookVizportalUrlId, siteUrls: urls }));
            }))));
}
exports.CalculationDetails = CalculationDetails;
//# sourceMappingURL=CalculationDetails.js.map